import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Business as BusinessIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  SupportAgent as SupportAgentIcon
} from '@mui/icons-material'
import { Button, Menu, MenuItem } from '@mui/material/'
import { alpha, styled } from '@mui/material/styles'

import OrbitSession from '../../../hooks/useCookies'
import useIdentity from '../../../hooks/useIdentity'

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      }
    }
  }
}))

export default function DemoMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const { setIdentity } = useIdentity()
  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const navigate = useNavigate()
  const enterDemoApp = () => {
    setIdentity((id) => {
      return {
        ...id,
        email: 'abc_client@orbitdemo.com',
        role: 'owner', // set
        orgId: 'abcOrgId', // set to a demo orgId
        _id: 'demoClientOwnerId', // set to demo
        userName: 'ABC Client'
      }
    })
    OrbitSession.set({
      email: 'abc_client@orbitdemo.com',
      role: 'owner', // set
      orgId: 'abcOrgId', // sets to a demo orgId
      _id: 'demoClientOwnerId', // set to demo
      userName: 'ABC Client'
    })
    navigate('/demo/app')
  }

  const enterDemoVendor = () => {
    setIdentity((id) => {
      return {
        ...id,
        email: 'demoOpsLead@orbitdemo.com',
        role: 'owner', // set
        orgId: 'demoOpsOrgId', // set to a demo orgId
        _id: 'demoOpsLeadId', // set to demo
        userName: 'Demo Ops Lead'
      }
    })
    OrbitSession.set({
      email: 'demoOpsLead@orbitdemo.com',
      role: 'opsowner', // set
      orgId: 'demoOpsOrgId', // set to a demo orgId
      _id: 'demoOpsLeadId', // set to demo
      userName: 'Demo Ops Lead'
    })
    navigate('/demo/hq')
  }

  return (
    <div>
      <Button
        id='demo-customized-button'
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='contained'
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Demos
      </Button>
      <StyledMenu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={enterDemoVendor}>
          <SupportAgentIcon />
          Ops
        </MenuItem>
        <MenuItem onClick={enterDemoApp}>
          <BusinessIcon />
          Client
        </MenuItem>
      </StyledMenu>
    </div>
  )
}
